@if (!inPopup) {
  <div class="flex justify-between items-center py-4">
    <h2 class="text-lg font-semibold text-indigo-900"> {{ 'DOCUMENT_HISTORY.TITLE' | translate }}</h2>
    <app-back-button></app-back-button>
  </div>
}

<div class="bg-white rounded-xl p-6">
  <div *ngIf="isLoading" class="text-center py-8 text-gray-500">
   {{ 'DOCUMENT_HISTORY.LOADING_HISTORY' | translate }}
  </div>

  <app-table
    *ngIf="!isLoading && documents.length > 0"
    [columns]="columns"
    [data]="documents"
    [actions]="actions"
    (linkClick)="downloadFile($event)">
  </app-table>

  <div *ngIf="!isLoading && documents.length === 0" class="text-center py-8 text-gray-500">
    {{ 'DOCUMENT_HISTORY.NO_HISTORY_FOUND' | translate }}
  </div>
</div>